var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "29px",
    viewBox: "0 0 22 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "np_map_1985127_000000") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.300000012
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-(Mobile-V2)",
    transform: "translate(-227.000000, -763.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 742.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(18.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(200.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_map_1985127_000000",
    transform: "translate(9.600000, 5.600000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4614054,28.0589838 C10.6972533,28.0589838 10.9342609,27.9702472 11.1152432,27.7916112 C11.5087116,27.4063027 20.7361494,18.2630642 20.7361494,10.3120972 C20.7361494,4.64709676 16.1265553,0.0375026439 10.4615549,0.0375026439 C4.79655438,0.0375026439 0.186960259,4.64709676 0.186960259,10.3120972 C0.186960259,18.2633631 9.41421872,27.4063326 9.80786646,27.7916112 C9.98883981,27.9702501 10.2258444,28.0589838 10.4617043,28.0589838 L10.4614054,28.0589838 Z M2.05491892,10.3119568 C2.05491892,5.67665747 5.82610612,1.90547027 10.4614054,1.90547027 C15.0967047,1.90547027 18.8678919,5.67665747 18.8678919,10.3119568 C18.8678919,16.329656 12.5432251,23.5638673 10.4614054,25.7810875 C8.37964551,23.5638673 2.05491892,16.329656 2.05491892,10.3119568 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0657297,10.3119568 C16.0657297,7.2213587 13.5519437,4.70763243 10.4614054,4.70763243 C7.37086713,4.70763243 4.85708108,7.22141848 4.85708108,10.3119568 C4.85708108,13.402495 7.37086713,15.9162811 10.4614054,15.9162811 C13.5519437,15.9162811 16.0657297,13.402495 16.0657297,10.3119568 Z M6.72518919,10.3119568 C6.72518919,8.25120934 8.40182369,6.57574054 10.4614054,6.57574054 C12.5209871,6.57574054 14.1976216,8.25120934 14.1976216,10.3119568 C14.1976216,12.3727042 12.5209871,14.048173 10.4614054,14.048173 C8.40182369,14.048173 6.72518919,12.3727042 6.72518919,10.3119568 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.d0cc6e395e030df794662ef1d65ba03f.svg";
export { ForwardRef as ReactComponent };